import { useSelector } from 'react-redux';
import cc from 'classcat';
import { RootState } from '../../../store';
import { Button, Input } from '..';
import { useEffect, useState } from 'react';

interface IDeleteModal {
    title: string;
    className?: string;
    description?: string;
    onYes: () => void;
    onNo: () => void;
    isNoContained?: boolean;
}

export const DeleteModal = ({ title, className, description, onYes, onNo, isNoContained = false }: IDeleteModal) => {
    const content = useSelector((state: RootState) => state.language.data);

    const [isYesDisabled, setIsYesDisabled] = useState(true);
    const [inputValue, setInputValue] = useState('');

    useEffect(() => {
        if (inputValue === 'delete') {
            setIsYesDisabled(false);
        } else {
            setIsYesDisabled(true);
        }
    }, [inputValue]);

    return (
        <div className={cc(['yes-no', 'delete-modal', className])}>
            <h3 className="yes-no__title">{title}</h3>
            {description && <p className={cc(['delete-modal__description', 'paragraph-3'])}>{description}</p>}
            <Input
                id="delete-modal__input"
                type="text"
                className="delete-modal__input"
                placeholder={content.common.enterToDeletePlaceholder}
                value={inputValue}
                onChange={e => setInputValue(e.target.value)}
            />
            <div className="yes-no__buttons">
                <Button onClick={onNo} text={content.common.no} variant={isNoContained ? 'contained' : 'text'} color="blue" />
                <Button disabled={isYesDisabled} text={content.common.yes} onClick={onYes} variant={isNoContained ? 'text' : 'contained'} />
            </div>
        </div>
    );
};
